<template>
  <form-section
    id="organization-section"
    :title="title"
    :is-first-section="false"
    :hasErrors="hasSectionErrors(errors, 'work')"
  >
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <label :for="application.time_type">Категория работ</label>
          <b-form-select id="time_type" v-model="application.time_type" :options="categories"
                         class="form-control"></b-form-select>
        </div>
      </div>
      <div class="col-md-8 col-sm-12">
        <div class="form-group">
          <label :for="'additional_purpose'">Описание работ</label>
          <b-form-input id="additional_purpose" v-model="application.additional_purpose"
                        class="form-control"></b-form-input>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <label :for="'subdivision_id'">Подразделение</label>
          <b-form-select id="time_type" v-model="application.subdivision_id"
                         :options="subdivisions.reduce((obj, item) => Object.assign(obj, { [item.id]: item.name }), {})"
                         class="form-control"></b-form-select>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <label :for="'form-pass-date-of'">Дата начала работ</label>
          <date-picker
            id="form-pass-date-of"
            format="DD.MM.YYYY"
            v-model="application.period_of"
          />
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <label :for="'form-pass-date-to'">Дата окончания работ</label>
          <date-picker
            id="form-pass-date-to"
            format="DD.MM.YYYY"
            v-model="application.period_to"
          />
        </div>
      </div>
    </div>
    <TimeOfWorkList :time-of-work="timeOfWork" :time-of-work-ids="timeOfWorkIds"/>
  </form-section>
</template>

<script>
import FormSection from '../application/FormSection'
import hasErrorsMixin from '../../mixins/hasErrorsMixin'
import WorkCategory from '../../enums/WorkCategory'
import TimeOfWorkList from './TimeOfWorkList'

export default {
  name: 'WorkSection',
  mixins: [hasErrorsMixin],
  components: { TimeOfWorkList, FormSection },
  props: {
    title: {
      type: String,
      default: 'Работы'
    },
    application: {
      type: Object
    },
    subdivisions: {
      type: Array,
      required: true
    },
    updateApplication: {
      type: Function,
      required: true
    },
    timeOfWork: {
      type: Object
    },
    timeOfWorkIds: {
      type: Array
    }
  },

  data () {
    return {
      errors: {
        type: Array,
        default: []
      }
    }
  },

  computed: {
    categories: () => {
      return WorkCategory
    }
  }
}
</script>
